import React, { useMemo } from 'react';
import { useStores } from '../stores/useStores';


export function useBoundaryLayers(fillOpacity) {
  const { traplogStore } = useStores();

  const layers = useMemo(
    () => [
      {
        id: 'layerStyleThresholdMet',
        type: 'fill',
        paint: {
          'fill-color': '#DC3545',
          'fill-opacity': fillOpacity[0]
        },
        filter: [
          'any',
          ['==', 'status', 'pre_trap_catch_threshold_met'],
          ['==', 'status', 'accumulation_threshold_met'],
          ['==', 'status', 'average_threshold_met']
        ]
      },
      {
        id: 'layerStyleNearThreshold',
        type: 'fill',
        paint: {
          'fill-color': '#FFC107',
          'fill-opacity': fillOpacity[0]
        },
        filter: ['==', 'status', 'near_accumulation_threshold']
      },
      {
        id: 'layerStyleGood',
        type: 'fill',
        paint: {
          'fill-color': '#28A745',
          'fill-opacity': fillOpacity[0]
        },
        filter: ['any', ['==', 'status', 'good'], ['==', 'status', 'sprayed']]
      },
      {
        id: 'layerStyleNoData',
        type: 'fill',
        paint: {
          'fill-color': '#6C757D',
          'fill-opacity': fillOpacity[1]
        },
        filter: ['==', 'status', 'no_data']
      },
      {
        id: 'layerOutlineStyleThresholdMet',
        type: 'line',
        paint: {
          'line-color': '#DC3545',
          'line-width': fillOpacity[2]
        },
        filter: [
          'any',
          ['==', 'status', 'pre_trap_catch_threshold_met'],
          ['==', 'status', 'accumulation_threshold_met'],
          ['==', 'status', 'average_threshold_met']
        ]
      },
      {
        id: 'layerOutlineStyleNearThreshold',
        type: 'line',
        paint: {
          'line-color': '#FFC107',
          'line-width': fillOpacity[2]
        },
        filter: ['==', 'status', 'near_accumulation_threshold']
      },
      {
        id: 'layerOutlineStyleGood',
        type: 'line',
        paint: {
          'line-color': '#28A745',
          'line-width': fillOpacity[2]
        },
        filter: ['any', ['==', 'status', 'good'], ['==', 'status', 'sprayed']]
      },
      {
        id: 'layerOutlineStyleNoData',
        type: 'line',
        paint: {
          'line-color': '#6C757D',
          'line-width': fillOpacity[2]
        },
        filter: ['==', 'status', 'no_data']
      },
      {
        id: 'layerSelectedStyleThresholdMet',
        type: 'fill',
        paint: {
          'fill-color': '#DC3545',
          'fill-opacity': fillOpacity[3]
        },
        filter: [
          'all',
          [
            '==',
            'id',
            traplogStore.selectedTrappingZoneId
              ? traplogStore.selectedTrappingZoneId
              : 0
          ],
          [
            'any',
            ['==', 'status', 'pre_trap_catch_threshold_met'],
            ['==', 'status', 'accumulation_threshold_met'],
            ['==', 'status', 'average_threshold_met']
          ]
        ]
      },
      {
        id: 'layerSelectedStyleNearThreshold',
        type: 'fill',
        paint: {
          'fill-color': '#FFC107',
          'fill-opacity': fillOpacity[3]
        },
        filter: [
          'all',
          [
            '==',
            'id',
            traplogStore.selectedTrappingZoneId
              ? traplogStore.selectedTrappingZoneId
              : 0
          ],
          ['==', 'status', 'near_accumulation_threshold']
        ]
      },
      {
        id: 'layerSelectedStyleGood',
        type: 'fill',
        paint: {
          'fill-color': '#28A745',
          'fill-opacity': fillOpacity[3]
        },
        filter: [
          'all',
          [
            '==',
            'id',
            traplogStore.selectedTrappingZoneId
              ? traplogStore.selectedTrappingZoneId
              : 0
          ],
          ['any', ['==', 'status', 'good'], ['==', 'status', 'sprayed']]
        ]
      },
      {
        id: 'layerSelectedStyleNoData',
        type: 'fill',
        paint: {
          'fill-color': '#6C757D',
          'fill-opacity': fillOpacity[3]
        },
        filter: [
          'all',
          [
            '==',
            'id',
            traplogStore.selectedTrappingZoneId
              ? traplogStore.selectedTrappingZoneId
              : 0
          ],
          ['==', 'status', 'no_data']
        ]
      }
    ],
    [traplogStore.selectedTrappingZoneId]
  );

  return layers;
}